import { lazy } from "react";
import { Route } from "react-router-dom";
import Protected from "@/components/Protected";

const LaboratoryOrders    = lazy(() => import("@/pages/LaboratoryOrders"));
const LaboratoryDispense  = lazy(() => import("@/pages/LaboratoryDispense"));
const LabCollection       = lazy(() => import("@/pages/LabCollection"));
const LabSpecimens        = lazy(() => import("@/pages/LabSpecimens"));
const LabProcessing       = lazy(() => import("@/pages/LabProcessing"));
const LabResults          = lazy(() => import("@/pages/LabResults"));
const LabSettlements      = lazy(() => import("@/pages/LabSettlements"));
const LaboratoryDashboard = lazy(() => import("@/pages/LaboratoryDashboard"));

const L = ["laboratory"];
const LL = ["laboratory_staff", "laboratory"];

export default (
  <>
    {/* Legacy landing */}
    <Route path="/laboratory"             element={<Protected roles={LL}><LaboratoryDashboard /></Protected>} />

    {/* Shell */}
    <Route path="/laboratory/orders"      element={<Protected roles={L}><LaboratoryOrders /></Protected>} />
    <Route path="/laboratory/dispense"    element={<Protected roles={L}><LaboratoryDispense /></Protected>} />
    <Route path="/laboratory/collection"  element={<Protected roles={L}><LabCollection /></Protected>} />
    <Route path="/laboratory/specimens"   element={<Protected roles={L}><LabSpecimens /></Protected>} />
    <Route path="/laboratory/processing"  element={<Protected roles={L}><LabProcessing /></Protected>} />
    <Route path="/laboratory/results"     element={<Protected roles={L}><LabResults /></Protected>} />
    <Route path="/laboratory/settlements" element={<Protected roles={L}><LabSettlements /></Protected>} />
  </>
);
